<form [formGroup]="bestuurderFg">
  <ng-container formArrayName="bestuurders">
    @for (item of bestuurders.controls; track item; let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="row flex-nowrap">
          <ng-container formGroupName="managingOrSupervisoryDirectorOrRepresentativeName">
            <snelstart-ui-text-form-control formControlName="value"
              [label]="i === 0 ? 'Naam' : ''"
              id="naamBestuurder"
              [required]=true
              class="me-1 custom-input-225"
              (change)="this.saveForm()"
              >
            </snelstart-ui-text-form-control>
          </ng-container>
          <ng-container formGroupName="ondertekeningJaarrekening">
            <ng-container formGroupName="legalEntityNameManagingSupervisoryDirector">
              <snelstart-ui-text-form-control formControlName="value"
                [label]="i === 0 ? 'Naam rechtspersoon' : ''"
                id="legalEntityNameManagingSupervisoryDirector"
                class="me-1 custom-input-225"
                (change)="this.saveForm()">
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="directorType">
              <snelstart-ui-select-form-control formControlName="value"
                class="me-1 custom-input-150"
                [label]="i === 0 ? 'Soort' : ''"
                [options]="this.optionsBestuurderType"
                [required]=true
                (change)="saveForm()"
                >
              </snelstart-ui-select-form-control>
            </ng-container>
            <ng-container formGroupName="signatureManagingSupervisoryDirectorsLocation">
              <snelstart-ui-text-form-control formControlName="value"
                [label]="i === 0 ? 'Plaats ondertekening' : ''"
                id="signatureManagingSupervisoryDirectorsLocation"
                [required]=true
                class="me-1 custom-input-175"
                (change)="this.saveForm()"
                >
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="signatureManagingSupervisoryDirectorsDate">
              <snelstart-ui-date-form-control formControlName="value"
                [label]="i === 0 ? 'Datum ondertekening' : ''"
                id="signatureManagingSupervisoryDirectorsDate"
                [required]=true
                class="me-1 custom-input-175"
                (change)="this.saveForm()"
                >
              </snelstart-ui-date-form-control>
            </ng-container>
            <ng-container formGroupName="directorSignedStatus">
              <snelstart-ui-select-form-control formControlName="value"
                class="me-1 custom-input-125"
                [label]="i === 0 ? 'Ondertekend' : ''"
                [options]="this.optionsJaNee"
                [disabledControl]="true"
                (change)="saveForm()"
                >
              </snelstart-ui-select-form-control>
            </ng-container>
          </ng-container>
          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'pt-3' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
              >
            </snelstart-ui-button>
          </div>
        </div>
      </ng-container>
    }
  </ng-container>
</form>

<div>
  <snelstart-ui-button id="addB" class="snelstart-ui-button pb-3" type="link" icon="plus"
    (click)="addRij()">Item toevoegen
  </snelstart-ui-button>
</div>
